export class MissingBuroError extends Error {
  constructor(...params) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MissingBuroError);
    }

    this.name = 'MissingBuroError';
    // Custom debugging information
    this.message = 'No pudimos consultar tu buró de crédito. Por favor intenta más tarde.';
    this.date = new Date();
  }
}
